import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserServiceInterface } from '@hutsix/ngxh6';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    constructor(
        private router: Router,
        @Inject('UserService') public user: UserServiceInterface,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // do some checks here
        return this.user.watch.pipe(
            map(user => {
                if (!user || !user.loggedIn) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }

                // Issued a temporary password by staff: nothing else is reachable until
                // they've set their own. Checked before roles so it can't be skipped by
                // landing on a page they'd fail the role check for anyway.
                if ((user as any)?.account?.user?.mustChangePassword && !state.url.startsWith('/set-password')) {
                    this.router.navigate(['/set-password']);
                    return false;
                }

                if (route.data?.roles?.length && !this.user.isGranted(route.data.roles)) {
                    this.router.navigate(['/unauthorised'], { queryParams: { route: state.url } });
                    return false;
                }

                // Check for denied roles
                if (route.data?.deniedRoles?.length && route.data.deniedRoles.some((role: string) => this.user.hasRole(role))) {
                    this.router.navigate(['/unauthorised'], { queryParams: { route: state.url } });
                    return false;
                }

                return true;
            }),
        );
    }
}
